/**
 * Wrapper class for partial templates that preserves structure.
 * @param {Array} items The items in the partial.
 * @private
 */
class Partial {
    constructor(items) {
        this.items = items;
    }
}

export default Partial;
